import { useMatch } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import { useContext } from "react";
import PostList from "./PostList";

// Wide screens only. On narrow screens the post list lives in the menu.
const Sidebar = () => {
    const { posts } = useContext(AppContext);
    const match = useMatch("/posts/:post");

    // The empty column keeps page content aligned with post content.
    return <aside className={`hidden md:block md:w-52 lg:w-64 shrink-0 overflow-y-auto no-scrollbar`}>
        {match && posts.length > 0 && <PostList posts={posts} />}
    </aside>;
}

export default Sidebar;
